import StarCircle from '../src/StarCircle';
export default StarCircle;
